import { InputType } from 'config'

export const MldsDefaultInputs = (): Record<string, InputType> => ({
  compensationSection: {
    inputType: 'section',
    title: 'Compensation to Broker (Not Paid Out of Loan Proceeds)',
    span: 'full',
  },
  mortgageBrokerFee: {
    inputType: 'text',
    type: 'thousandSep',
    title: 'Mortgage Broker Commission Fee',
    prefix: '$',
  },
  custom1: {
    inputType: 'custom',
    title: '',
    span: 1,
  },
  addtionalCompFee: {
    inputType: 'text',
    type: 'thousandSep',
    title: 'Any Additional Compensation from Lender',
    prefix: '$',
    span: 1,
  },
  isAdditionalCompFee: {
    inputType: 'togglebutton',
    title: '',
    span: 1,
  },
})
